<template>
    <div id="shorts" :style="'height:' + shortsHeight" >
        <svg ref="svg" :height="svgHeight" :width="svgWidth" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" :viewBox="viewBox"></svg>
    </div>
</template>
<script>
export default {
  name: 'Shorts',
  props: ['color', 'view_box', 'svg_height', 'svg_width', 'shorts_height', 'sport'],
  data () {
    return {
      viewBox: '-140 0 800 800',
      svgHeight: '100px',
      svgWidth: '100px',
      shortsHeight: '65px'
    }
  },
  created () {
    // check if isset view_box param
    if (typeof this.view_box !== 'undefined') {
      this.viewBox = this.view_box
    }
    // check if isset svg_height
    if (typeof this.svg_height !== 'undefined') {
      this.svgHeight = this.svg_height
    }
    // check if isset svg_width
    if (typeof this.svg_width !== 'undefined') {
      this.svgWidth = this.svg_width
    }
    // check if isset shorts_height
    if (typeof this.shorts_height !== 'undefined') {
      this.shortsHeight = this.shorts_height
    }
  },
  mounted () {
    this.draw()
  },
  watch: {
    'color': function () {
      this.draw()
    }
  },
  methods: {
    draw () {
      // remove svg childs
      while (this.$refs.svg.firstChild) {
        this.$refs.svg.removeChild(this.$refs.svg.firstChild)
      }
      var polygon1 = document.createElementNS('http://www.w3.org/2000/svg', 'polygon')
      polygon1.setAttribute('points', '28.792,74.52 28.792,135.302 211.163,135.302 211.163,120.028 241.39,120.028 241.39,135.302 271.617,135.302 271.617,120.028 301.845,120.028 301.845,135.302 483.208,135.302 483.208,74.52')
      polygon1.setAttribute('fill', (this.color ? this.color : '#FFFFFF'))
      polygon1.setAttribute('stroke', 'black')
      polygon1.setAttribute('stroke-width', '20')
      // polygon2
      var polygon2 = document.createElementNS('http://www.w3.org/2000/svg', 'polygon')
      polygon2.setAttribute('points', '512,437.48 484.795,165.53 301.845,165.53 301.845,241.259 271.617,241.259 271.617,165.53 241.39,165.53 241.39,241.259 211.163,241.259 211.163,165.53 27.205,165.53 0,437.48 241.39,437.48 241.39,346.732 271.617,346.732 271.617,437.48')
      polygon2.setAttribute('fill', (this.color ? this.color : '#FFFFFF'))
      polygon2.setAttribute('stroke', 'black')
      polygon2.setAttribute('stroke-width', '20')
      this.$refs.svg.appendChild(polygon1)
      this.$refs.svg.appendChild(polygon2)
    }
  }
}
</script>
<style lang="scss" scoped>
    #shorts {
        text-align: center;
        overflow: hidden;
    }
</style>
